export default __webpack_public_path__ + "static/media/raphael.a2edd424.jpg";